import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useSubscribe } from '@/js/libs/observable/index.ts';
import { OnHover } from '../../Components/OnHover/index.js';
import { Button } from '../../Controls/Button/index.js';
import { Tooltip } from '../../Feedback/Tooltip/index.js';
import Icons from '../Icons/index.js';
export const UnavailableIcon = ({ tooltip, onClick, pending$, }) => {
    const theme = useTheme();
    const pending = useSubscribe((ctx) => (pending$ ? ctx.spy(pending$) : false));
    return (_jsx(OnHover, { children: (hovered) => (_jsx(Tooltip, { tooltip: tooltip, placement: 'top', ContainerComponent: Button, containerComponentProps: { ghost: true, onClick, isLoading: pending, disabled: pending }, children: _jsx(Icons.TemporaryUnavailable, { filled: hovered, size: 24, color: theme.colors.link70 }) })) }));
};
